import { fields, mutation, query } from "./utils";

export const listBanks = (strings: TemplateStringsArray, ...vars: string[]) =>
  query("ListBanks", "listBanks", "ModelListInput", fields(strings, ...vars));

export const getBank = (strings: TemplateStringsArray, ...vars: string[]) =>
  query(
    "GetWorkspace",
    "getWorkspace",
    "ModelGetInput",
    fields(strings, ...vars),
  );

export const createBank = (strings: TemplateStringsArray, ...vars: string[]) =>
  mutation(
    "CreateBank",
    "createBank",
    "CreateBankInput!",
    fields(strings, ...vars),
  );

export const updateBank = (strings: TemplateStringsArray, ...vars: string[]) =>
  mutation(
    "UpdateBank",
    "updateBank",
    "UpdateBankInput!",
    fields(strings, ...vars),
  );

export const deleteBank = (strings: TemplateStringsArray, ...vars: string[]) =>
  mutation(
    "DeleteBank",
    "deleteBank",
    "DeleteBankInput!",
    fields(strings, ...vars),
  );
